
ko.bindingHandlers.percentageToRating = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var val = parseFloat(ko.unwrap(valueAccessor()));

        if (val <= 0.25) {
            element.textContent = 'Low';
        } else if (val > 0.25 && val <= 0.75) {
            element.textContent = 'Medium';
        } else if (val > 0.75) {
            element.textContent = 'High';
        }
    }
};